import { render, staticRenderFns } from "./Circle3.vue?vue&type=template&id=20c22e53&scoped=true&"
import script from "./Circle3.vue?vue&type=script&lang=js&"
export * from "./Circle3.vue?vue&type=script&lang=js&"
import style0 from "./Circle3.vue?vue&type=style&index=0&id=20c22e53&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c22e53",
  null
  
)

export default component.exports